enum RolloutPhase {
    AWAITING_DISPATCH = 'AWAITING_DISPATCH',
    PILOT_IN_PROGRESS = 'PILOT_IN_PROGRESS',
    PILOT_FAILED = 'PILOT_FAILED',
    BATCH_IN_PROGRESS = 'BATCH_IN_PROGRESS',
    DONE = 'DONE',
    CANCELLED = 'CANCELLED',
}

export default RolloutPhase;
